export default __webpack_public_path__ + "static/media/ic-star-outLine.f7104d84.svg";